import { render } from "./SingleEconomyFileUpload.vue?vue&type=template&id=0bdcd84c"
import script from "./SingleEconomyFileUpload.vue?vue&type=script&lang=js"
export * from "./SingleEconomyFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__